/** Numéro principal affiché sur le site */
export const SITE_PHONE_DISPLAY = '07 60 47 93 74';
export const SITE_PHONE_TEL = '+212760479374';
export const SITE_PHONE_WA = '212760479374';
export const SITE_EMAIL = 'saharavisite@gmail.com';
export const SITE_EMAIL_MAILTO = `mailto:${SITE_EMAIL}`;

